import gql from 'graphql-tag';

export const GET_PAGE = gql`
  query($url: String!) {
    page(url: $url) {
      ... on CMSAboutUsPage {
        locales {
          fr {
            member {
              bio
              bioImage {
                height
                url
                width
              }
              firstName
              lastName
              link
              memberExecutiveTeam
              title
            }
            meta {
              content
              title
              description
              image {
                url
              }
              name
              provider
              title
              type
            }
            pressCoverage {
              alt
              content
              image {
                height
                url
                width
              }
            }
            sections {
              ctaUrl
              ctaLabel
              ctaDisclaimer
              description
              image {
                url
              }
              imageAlt
              mobileImage {
                url
              }
              name
              title
            }
            title
          }
        }
        member {
          bio
          bioImage {
            height
            url
            width
          }
          firstName
          lastName
          link
          memberExecutiveTeam
          title
        }
        meta {
          content
          title
          description
          image {
            url
          }
          name
          provider
          title
          type
        }
        pressCoverage {
          alt
          content
          image {
            height
            url
            width
          }
        }
        sections {
          ctaUrl
          ctaLabel
          ctaDisclaimer
          description
          image {
            url
          }
          imageAlt
          mobileImage {
            url
          }
          name
          title
        }
        title
        type
        url
      }
      ... on CMSLandingPage {
        actions {
          eventAttributes {
            name
            value
          }
          name
          tagType
          trigger
          type
          value
        }
        adsSdk
        canonicalUrl
        faqs {
          questions {
            faq {
              answer
              question
              title
            }
          }
          title
        }
        imageSets {
          images {
            alt
            content
            image {
              height
              url
              width
            }
          }
          name
        }
        locales {
          fr {
            faqs {
              title
            }
            imageSets {
              images {
                alt
                content
                image {
                  height
                  url
                  width
                }
              }
              name
            }
            meta {
              content
              description
              image {
                url
              }
              name
              provider
              title
              type
            }
            partnerLogo {
              alt
              image {
                height
                url
                width
              }
            }
            partnerMobileLogo {
              alt
              image {
                height
                url
                width
              }
            }
            saveHeadline
            sectionList {
              backgroundColor
              blocks {
                alt
                ctaDisclaimer
                ctaLabel
                ctaUrl
                customHtml
                description
                descriptionAlignment
                descriptionSize
                image {
                  url
                }
                title
                titleAlignment
                titleImage {
                  url
                }
                titleSize
                responsiveImageSet {
                  desktopImage {
                    url
                  }
                  mobileImage {
                    url
                  }
                  tabletImage {
                    url
                  }
                }
                offsetLeft
                offsetRight
                imageBesideCta {
                  url
                }
              }
              ctaDisclaimer
              ctaLabel
              ctaUrl
              displayName
              name
              subtitle
              textColor
              title
              titleImage {
                url
              }
              offsetLeft
              offsetRight
              textBgColor
            }
            sections {
              ctaLabel
              ctaUrl
              ctaDisclaimer
              description
              footer
              image {
                url
              }
              imageAlt
              mobileImage {
                url
              }
              name
              title
            }
            statsHeadline
            title
          }
        }
        meta {
          content
          description
          image {
            url
          }
          name
          provider
          title
          type
        }
        partnerLogo {
          alt
          image {
            height
            url
            width
          }
        }
        partnerMobileLogo {
          alt
          image {
            height
            url
            width
          }
        }
        product {
          description
          id
          name
          offers {
            price {
              currency
              amount
            }
            url
          }
          productImages {
            image {
              url
            }
          }
        }
        saveHeadline
        sectionList {
          backgroundColor
          blocks {
            alt
            ctaDisclaimer
            ctaLabel
            ctaUrl
            customHtml
            description
            descriptionAlignment
            descriptionSize
            image {
              url
            }
            title
            titleAlignment
            titleImage {
              url
            }
            titleSize
            responsiveImageSet {
              desktopImage {
                url
              }
              mobileImage {
                url
              }
              tabletImage {
                url
              }
            }
            offsetLeft
            offsetRight
            imageBesideCta {
              url
            }
          }
          ctaDisclaimer
          ctaLabel
          ctaUrl
          displayName
          name
          subtitle
          textColor
          title
          titleImage {
            url
          }
          offsetLeft
          offsetRight
          textBgColor
        }
        sections {
          ctaLabel
          ctaUrl
          ctaDisclaimer
          description
          footer
          image {
            url
          }
          imageAlt
          mobileImage {
            url
          }
          name
          title
        }
        statsHeadline
        quotes {
          quote {
            alt
            image {
              height
              width
              url
            }
            name
            quote
            title
          }
        }
        title
        type
        url
      }
    }
  }
`;
